/**
 * ما إذا كان المنتج يجب ألا يُعرض في الواجهة.
 * يُعتمد على حقل hidden من الـ API / قاعدة البيانات فقط.
 */
export function isProductHiddenFromUI(p: { hidden?: boolean }): boolean {
  return p.hidden === true;
}
